module.exports = __webpack_public_path__ + "img/open_event.a0d99e4b.jpg";